import { Injectable } from '@angular/core';
import { ConfigurationService } from '../configuration/configuration.service';

@Injectable()
export class TranslateService {
  private undeclaredLanguage: {
    [keyWord: string]: boolean
  } = {};
  private currentLanguage: string;
  private dictionary: {
    [language: string]: {
      [keyWord: string]: string
    }
  } = {};

  constructor(private configurationService: ConfigurationService) {
    const translateConfiguration = this.configurationService.getTranslateConfiguration();
    if (translateConfiguration) {
      this.currentLanguage = translateConfiguration.defaultLanguage;
      this.dictionary = translateConfiguration.initializeDictionary?.() || {};
    }
  }

  translate = (keyWord: string, language?: string) => {
    if (!keyWord) {
      return '';
    }
    keyWord = keyWord.toString().trim();
    language = language || this.currentLanguage;
    if (!keyWord || !language) {
      return keyWord;
    }
    if (!this.dictionary[language]?.[keyWord]) {
      if (!this.undeclaredLanguage[keyWord]) {
        this.undeclaredLanguage[keyWord] = true;
      }
      return keyWord;
    }
    return this.dictionary[language][keyWord];
  }

  setDictionary = (language: string, keyWord: string, value: string) => {
    if (!this.dictionary[language]) {
      this.dictionary[language] = {
        [keyWord]: value
      };
    } else {
      this.dictionary[language][keyWord] = value;
    }
  }

  setDictionaries = (language: string, dictionary: {
    [keyWord: string]: string
  }) => {
    this.dictionary[language] = dictionary;
  }

  setDefaultLanguage = (language: string) => {
    this.currentLanguage = language;
  }

  getUndeclaredLanguage = () => this.undeclaredLanguage;
}
